import GetApi from '../../common/api/get'
import PutApi from '../../common/api/put'
import i18n from '../../i18n'
const skipReload = true

export function setState(params, type) {
  return {
    type: type || 'SET_STATE_REVIEW',
    params: params
  }
}

// レビュー一覧の画面遷移時の描画ラグ軽減のため、
// 一度取得したJSONのキャッシュを保持するオブジェクト
// キャッシュがあってもAPIリクエストは都度送信し、
// リクエスト成功時にキャッシュを更新する
const memoryCache = {}

export const index = (userId, params = {}, { type, url, reset } = {}) => {
  return (dispatch) => {
    const key = JSON.stringify({ userId, params, type, url })

    if (memoryCache[key]) {
      dispatch(memoryCache[key])
    } else if (reset) {
      dispatch(setState({}, 'RESET_STATE_REVIEWS'))
    }

    return new GetApi().execute(url || routeUrlHelper.reviewsPath(userId), params).then((res) => {
      dispatch(memoryCache[key] = setState({
        results: res.body,
        pagination: JSON.parse(res.headers['x-pagination'] || 'null')
      }, type || 'SET_STATE_REVIEWS'))
    }).catch((res) => {
      let message = i18n.t('common:review.error.occur')
      res = res || {}

      if (res.statusCode == 404 || res.statusCode == 401) {
        message = i18n.t('common:review.error.no_data')
      }
      const state = Object.assign({}, res.body, { errors: { main: message, code: res.statusCode } })
      dispatch(setState(state, type || 'SET_STATE_REVIEWS'))
    })
  }
}

export const writable = (userId, params = {}) => {
  return index(userId, { writable: 1 }, { type: 'SET_STATE_WRITABLE_REVIEWS' })
}

export const forListing = (listingId, params = {}) => {
  return index(listingId, params, { url: routeUrlHelper.listingReviewsPath(listingId) })
}

export const get = (id, params = {}) => {
  return (dispatch) => {
    return new GetApi({ skipReload }).execute(routeUrlHelper.travelReviewPath(id, 'json'), params).then((res) => {
      dispatch(setState(res.body))
    }).catch((res) => {
      let message = i18n.t('common:review.error.occur')
      res = res || {}

      if (res.statusCode == 404 || res.statusCode == 401) {
        message = i18n.t('common:review.error.no_data')
      }
      if (res.statusCode == 410) {
        message = i18n.t('common:review.error.expired')
      }
      dispatch(setState(Object.assign({}, res.body, { errors: { main: message, code: res.statusCode } })))
    })
  }
}

export const put = (id, params = {}) => {
  return (dispatch) => {
    return new PutApi({ skipReload }).execute(routeUrlHelper.travelReviewPath(id, 'json'), params).then((res) => {
      dispatch(setState(res.body))
    }).catch((res) => {
      let message = i18n.t('common:review.error.occur')
      res = res || {}

      if (res.statusCode == 404 || res.statusCode == 401) {
        message = i18n.t('common:review.error.no_data')
      }
      if (res.statusCode == 410) {
        message = i18n.t('common:review.error.expired')
      }
      dispatch(setState(Object.assign({}, res.body, { errors: { main: message, code: res.statusCode } })))
    })
  }
}

export const set = (review) => {
  return (dispatch) => {
    dispatch(setState(review))
  }
}
